export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["プログラム参加履歴に戻る"])}
    }
  })
}
